module.exports = __webpack_public_path__ + "7601be35a2629ced1c574a66eb2fb93d.glb";